module.exports = __webpack_public_path__ + "static/about-developer3-eca7fde9ec46e4472a4813ba5cdfbc43.jpg";